// extracted by mini-css-extract-plugin
module.exports = {"voucher-page":"VoucherPage_voucher-page__1u3VF","button-done":"VoucherPage_button-done__92EGQ"};